import BadgeRequestContainer from "../../../Component/Application/BadgeRequest/BadgeRequestContainer";

const BadgeRequestPage = () => {
     return (
        <div className="page-body">
            <BadgeRequestContainer/>
        </div>
     );
};

export default BadgeRequestPage;